export enum SoftwareServices {
  websiteService = 'DEV',
  seoService = 'SEO',
  smmService = 'SMM',
  googleMyBusinessService = 'GMB',
  ecommerceService = 'ECOM',
  blogService = 'BLOG',
  calendarService = 'CAL',
  epkService = 'EPK',
  vipService = 'VIP',
  setup = 'SETUP'
}